import { Box, ClickAwayListener, Grid, Typography } from '@mui/material'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import { routeName } from 'routes/routes-name'
import * as XLSX from "xlsx"
/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/**API */
import ClinicApi from 'api/master/clinic.api'
import ReportApi, { FindAllReportInterface } from 'api/report.api'
import { getBranch, getClinicInfo, toBuddhistYear } from 'utils/app.utils'
import { setItem as setSecureItem } from 'utils/secureStorage'

/**COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import { useDownloadExcel } from 'component/Excel/hooks/useExcel'
import InputCheckbox from 'component/Input/InputCheckbox'
import InputSecondNewDatePicker, { PICKER_VIEWS } from 'component/Input/InputSecondNewDatePicker'
import Loading from 'component/Loading'
import { useFunctionPrint } from 'component/Print/print'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import { colors } from 'constants/theme'
import { CustomFilterDoctor, ListFilterDoctors } from 'features/counter/appointment/head-appointment'
import * as UseStyled from 'features/report/useStyled'
import DfLabList from './DfLabList'

/**STYLE */

import AboutUs from 'api/admin/clinic-manage/about.api'
import { editBranchInfo } from 'app/slice/user.slice'
import { KEY_STORAGE } from 'constants/common'
import DropdownButton from 'new-components/buttons/dropdown-button'
import MainButton from 'new-components/buttons/main-button'
import RadioButton from 'new-components/buttons/radio-button'
import SelectInput from 'new-components/inputs/select-input'
import SelectCheckBoxInput from 'new-components/inputs/select_checkbox_input'
import { useDispatch } from 'react-redux'
import { ReportFormulaDF } from '../report-option-df'

interface TransformedData {
  doctor: {
    fullName: string;
    timeStart: string | null;
    timeEnd: string | null;
    countAppointment: number | null;
    countTreatment: number | null;
    handInsurance: number;
  };
  df: any[]; // Replace 'any[]' with the correct type for doctorDf
  lab: any[]; // Replace 'any[]' with the correct type for doctorLab
}
type Doctors = {
  userId: number
  firstname: string
  lastname: string
  fullname: string
  schedule: number | null
}

export interface DentistInterface {
  dentistId: number
  dentistFullname: string
}

export interface DentistNodataInterface {
  dentistFullname: string
  data: string
  branch: string
}

interface NewRowDF {
  doctorFullname: string,
  timeStart: string,
  timeEnd: string,
  date: string,
  doctorId: number,
  appointments: number,
  notYet: number,
  walkIn: number,
  handInsurance: number,
  total: number,
  df: number,
  creditCost: number,
  clinicFeePrice: number,
  treatmentRight: number,
  dfNet: number,
  labCost: number
}


export default function Df() {
  const { t } = useTranslation()
  const history = useHistory()
  const componentRef = useRef<any>(null)
  const componentRefCover = useRef<any>(null)
  const componentRefExcel = useRef<any>(null)
  const queryParams = new URLSearchParams(window.location.search)
  const clinicInfo = getClinicInfo()
  const dispatch = useDispatch()

  const userIdFromParam = Number(queryParams.get('doctorId'))
  const conditionFromParam: any = queryParams.get('condition')

  const momentNow = moment().format('YYYY-MM-DD')
  const [branchId, setBranchId] = useState<any>(getBranch())
  const [branches, setBranches] = useState<any[]>([])
  const [rowCount, setRowCount] = useState<number>(0)
  const [sortBy, setSortBy] = useState<string>('createAt')
  const [sortType, setSortType] = useState<string>('ASC')
  const [doctors, setDoctors] = useState<Doctors[]>([])
  const [fetch, setFetch] = useState(false)
  const [dfData, setDfData] = useState<any[]>([])
  const [coverData, setCoverData] = useState<any[]>([])

  const [date, setDate] = useState<string>(momentNow)
  const [page, setPage] = useState<number>(1)
  const [pageLimit, setPageLimit] = useState<number>(10)
  const [display, setDisplay] = useState('day')
  const [loading, setLoading] = useState<boolean>(true)
  const [selectDoctors, setSelectDoctors] = useState<any[]>([])
  const [doctorSchedule, setDoctorSchedule] = useState<any[]>([])
  const [optionDf, setOptionDf] = useState<'0' | '1' | '2' | '3'>(conditionFromParam || clinicInfo?.defaultDfCon || '1')
  const [rowsData, setRowsData] = useState<NewRowDF[]>([])

  const [openFilterDoctors, setOpenFilterDoctors] = useState(false)

  const [popFormula, setPopFormula] = useState<boolean>(false)
  const [imageFormula, setImageFormula] = useState<string>('')
  const [exporting, setExporting] = useState<boolean>(false)
  const [exportingMessage, setExportingMessage] = useState<string>('')
  const branchInfo = getClinicInfo()
  const isFetchingRef = useRef(false)
  const isFirstRun = useRef(true)
  const didInitialFetch = useRef(false)

  const loadPermissExport = useCallback(async () => {
    const branchId = getBranch()
    AboutUs.detailClinic(Number(branchId))
      .then(({ data }) => {
        dispatch(editBranchInfo({ value: { ...data } }))
        setSecureItem(KEY_STORAGE.CLINIC_INFO, JSON.stringify({ ...data, lastUpdate: moment().format('YYYY-MM-DD HH:mm') }))
      })
      .catch((e) => { return })
  }, [])

  useEffect(() => {
    loadPermissExport()
  }, [])

  useEffect(() => {
    setOptionDf(branchInfo?.defaultDfCon || '1')
  }, [branchInfo])

  const handleFilterDoctors = (value: any) => {
    if ((value === 'ALL' && _.size(selectDoctors.filter((item) => typeof item === 'number')) === _.size(doctors)) || value === 'CLEAR') setSelectDoctors([''])
    else if (value === 'ALL') setSelectDoctors([..._.map(doctors, (d: any) => d.userId)])
    else if (_.includes(selectDoctors, value)) setSelectDoctors(_.filter(selectDoctors, (d) => d !== value))
    else setSelectDoctors([...selectDoctors, value])
  }

  const getAllFilter = () => {
    return [
      {
        label: t('REPORT.FILTER.BRANCH'),
        value: _.get(_.find(branches, { branchId }), 'branchName') || _.get(_.find(branches, { branchId }), 'branchNameEn')
      },
      {
        label: display === 'day' ? t('REPORT.FILTER.DAY') : t('REPORT.FILTER.MONTH'),
        value: display === 'day' ? toBuddhistYear(moment(date), 'DD/MM/YYYY') : toBuddhistYear(moment(date), 'MMMM YYYY')
      },
      {
        label: t('REPORT.FILTER.DOCTOR'),
        value: getFilterUser()
      }
    ]
  }

  const getFilterUser = () => {
    if (doctors.length && doctors.every((d: any) => selectDoctors.includes(d.userId))) {
      return ` ${t('REPORT.REPORT_GROUP.ALL')}`
    }
    return doctors
      .filter((d: any) => selectDoctors.includes(d.userId))
      .map((d: any) => d.fullname)
      .filter((fullname) => fullname)
  }

  const verifyPermission = async () => {
    ClinicApi.findAllBranches()
      .then(({ data }) => setBranches(data))
      .catch((e) => {
        return
      })
    if (!userIdFromParam) {
      const condition: FindAllReportInterface = {
        page: 1,
        pageLimit: 200
      }
      ReportApi.reportList(condition).then(({ data }) => {
        const check = _.find(data, (val: any) => String(val.reportKey) === 'DF_LAB') ? true : false
        if (!check) {
          history.push(routeName.report)
          return false
        }
      })
    }
    return true
  }

  useEffect(() => {
    verifyPermission()
  }, [branchId])



  const fetchDoctor = useCallback(async () => {
    ClinicApi.findAllDoctors(date, display, date, date)
      .then((resp) => {
        setDoctors([{ userId: 999999, firstname: '', lastname: '', fullname: t('REPORT.TITLE.NO_DOCTOR'), schedule: null }, ...resp.data])
        setDoctorSchedule(_.map(_.filter(resp.data, (d) => d.userId === d.schedule), (d: any) => d.userId))
        setSelectDoctors(['DOCTOR_SCHEDULE', 999999, ...resp.data.map((d: any) => d.userId)])
      })
      .catch((e) => {
        return
      })
  }, [branchId, date, display])

  useEffect(() => {
    if (date !== 'Invalid date' && date) {
      ClinicApi.findAllDoctors(date, display, date, date)
        .then((resp) => {
          setDoctors([{ userId: 999999, firstname: '', lastname: '', fullname: t('REPORT.TITLE.NO_DOCTOR'), schedule: null }, ...resp.data])
          setDoctorSchedule(_.map(_.filter(resp.data, (d) => d.userId === d.schedule), (d: any) => d.userId))
          setSelectDoctors(['DOCTOR_SCHEDULE', 999999, ...resp.data.map((d: any) => d.userId)])
        })
        .catch((e) => {
          return
        })
    }
  }, [date])


  const fetchDF = async () => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    setLoading(true)

    let condition: any = {
      page: page,
      pageLimit: pageLimit,
      branchId: branchId,
      date: date,
      display: display
    }

    if (doctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }
    if (userIdFromParam) condition = { ...condition, doctorId: userIdFromParam }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (optionDf) condition = { ...condition, optionDf: Number(optionDf) }

    try {
      const response = await ReportApi.reportDfLab(condition)
      setDfData(response.data)
      setRowCount(response.headers['x-total'])
    } catch (e) {
      // Handle error if needed
    } finally {
      setLoading(false)
      isFetchingRef.current = false
      setFetch(false)
    }
  }

  // useEffect สำหรับ fetch เมื่อกดปุ่มค้นหา
  useEffect(() => {
    if (fetch) {
      fetchDF()
      fetchCover()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetch])

  // fetch ครั้งแรก: รอจนข้อมูลหมอ (selectDoctors) โหลดเสร็จก่อน แล้วค่อยโหลด report
  //   - ปกติ: selectDoctors ถูกเซ็ตหลัง findAllDoctors resolve → fetch ตอนนั้น (รอหมอก่อน)
  //   - deep-link ระบุ doctorId (userIdFromParam): ไม่ต้องรอ list หมอ → fetch ได้เลย
  //   - didInitialFetch กัน fetch ซ้ำตอน user toggle เลือกหมอ (ซึ่งก็เปลี่ยน selectDoctors)
  useEffect(() => {
    if (didInitialFetch.current) return
    if (userIdFromParam || selectDoctors.length > 0) {
      didInitialFetch.current = true
      fetchDF()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectDoctors, userIdFromParam])

  // useEffect สำหรับ dependencies อื่นๆ (pageLimit, sortBy, sortType, display)
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false
      // ไม่ fetch ตอน mount — รอข้อมูลหมอก่อน (ดู initial fetch effect ด้านบน)
      return
    }
    // เรียก API เฉพาะเมื่อมีการเปลี่ยนแปลง dependencies และไม่ได้กำลัง fetch
    if (!fetch && !isFetchingRef.current) {
      fetchDF()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLimit, sortBy, sortType, display])

  const fetchCover = useCallback(async () => {
    let condition: any = {
      page: page,
      pageLimit: pageLimit,
      branchId: branchId,
      date: date,
      display: 'month'
    }

    if (doctors) {
      const doctor = _.filter(selectDoctors, (v: any) => v > 0).join(',')
      if (doctor) condition = { ...condition, doctorId: _.filter(selectDoctors, (v: any) => v > 0).join(',') }
    }
    if (userIdFromParam) condition = { ...condition, doctorId: userIdFromParam }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (optionDf) condition = { ...condition, optionDf: Number(optionDf) }

    setFetch(false)
    return ReportApi.reportDfLab(condition)
      .then(({ headers, data }) => {
        setCoverData(data)
        return data
      })
      .catch((e) => {
        setLoading(false)
        return []
      })
      .finally(() => {
        setLoading(false)
      })
  }, [page, pageLimit, sortBy, sortType, fetch, display])

  const { onDownload } = useDownloadExcel({
    tableExportRef: componentRef.current,
    filename: `${t(`REPORT.REPORT_NAME.DF_LAB`)} (${date})`,
    sheetName: `${t(`REPORT.REPORT_NAME.DF_LAB`)}`
  })

  const onRequestSort = useCallback((sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }, [])

  const handleChangeRowsPerPage = useCallback((limit: number) => setPageLimit(limit), [])

  const handleChangePage = useCallback((val: number) => setPage(val), [])

  useEffect(() => {
    if (!userIdFromParam) fetchDoctor()
  }, [fetchDoctor])




  useEffect(() => {
    if (imageFormula === '') {
      setPopFormula(false)
    } else {
      setPopFormula(true)
    }
  }, [imageFormula])


  const serialNumberToThaiDate = (serial: number) => {
    const utcDays = Math.floor(serial - 25569); // 25569 คือวันที่ 1970-01-01 ตาม Excel
    const utcValue = utcDays * 86400 * 1000;
    const date = new Date(utcValue);
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${month}/${day}/${year}`;
  };

  /** พิมพ์ PDF ผ่าน FunctionPrint (iframe + clone content + copy stylesheets) — ใช้ @page A4 มาตรฐาน + บังคับ body width เท่า A4 เพื่อให้ iOS/iPad render ที่ขนาดคงที่ (ไม่ย่อตาม iframe viewport) */
  const handlePrintPdf = useFunctionPrint({
    content: () => componentRef.current,
    removeIfram: true,
    docTitle: t(`REPORT.REPORT_NAME.DF_LAB`),
    style: `
      @page { size: A4 landscape; margin: 0.5cm; }
      html, body { width: 1122.519685px; margin: 0; padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      body > * { width: 1122.519685px; max-width: 1122.519685px; }
      @media print {
        html, body { width: 1122.519685px; }
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `,
  })

  const handlePrintCover = useFunctionPrint({
    content: () => componentRefCover.current,
    removeIfram: true,
    docTitle: t(`REPORT.REPORT_NAME.DF_LAB`),
    style: `
      @page { size: A4 portrait; margin: 0.5cm; }
      html, body { width: 793.7007874px; margin: 0; padding: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      body > * { width: 793.7007874px; max-width: 793.7007874px; }
      @media print {
        html, body { width: 793.7007874px; }
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `,
  })

  /** iPad/iPhone: iframe-based print (FunctionPrint) ของ iOS Safari จะ print parent doc แทน + scale ตาม iframe viewport
   *  → ใช้ body-swap: clone print-area เข้าเป็น direct child ของ <body>, ซ่อน element อื่น @media print, แล้วเรียก window.print() */
  const isIosDevice = () => {
    if (typeof navigator === 'undefined') return false
    const ua = navigator.userAgent || ''
    const iOSUa = /iPad|iPhone|iPod/.test(ua)
    const iPadOS = navigator.platform === 'MacIntel' && (navigator as any).maxTouchPoints > 1
    return iOSUa || iPadOS
  }

  const printOnIos = (
    sourceEl: HTMLElement | null,
    pageSize: 'A4 landscape' | 'A4 portrait',
    contentWidthPx: number,
    title: string
  ) => {
    if (!sourceEl) return
    const WRAPPER_ID = '__cliniter_ios_print__'
    const STYLE_ID = '__cliniter_ios_print_style__'

    document.getElementById(WRAPPER_ID)?.remove()
    document.getElementById(STYLE_ID)?.remove()

    const wrapper = document.createElement('div')
    wrapper.id = WRAPPER_ID
    wrapper.appendChild(sourceEl.cloneNode(true) as Node)

    const styleEl = document.createElement('style')
    styleEl.id = STYLE_ID
    styleEl.appendChild(document.createTextNode(`
      #${WRAPPER_ID} { display: none; }
      @media print {
        @page { size: ${pageSize}; margin: 0.5cm; }
        html, body {
          width: ${contentWidthPx}px !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: visible !important;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        body > *:not(#${WRAPPER_ID}) { display: none !important; }
        #${WRAPPER_ID} {
          display: block !important;
          width: ${contentWidthPx}px !important;
          max-width: ${contentWidthPx}px !important;
        }
        #${WRAPPER_ID} .print-show { display: block !important; }
        #${WRAPPER_ID} * { visibility: visible !important; }
      }
    `))

    const originalTitle = document.title
    document.title = title
    document.head.appendChild(styleEl)
    document.body.appendChild(wrapper)

    const cleanup = () => {
      wrapper.remove()
      styleEl.remove()
      document.title = originalTitle
      window.removeEventListener('afterprint', cleanup)
    }
    window.addEventListener('afterprint', cleanup)

    setTimeout(() => {
      window.print()
      // เผื่อ Safari บางเวอร์ชันไม่ยิง afterprint
      setTimeout(cleanup, 2000)
    }, 250)
  }



  const exportTableToExcel = () => {
    if (!componentRefExcel.current) return
    setExporting(true)
    setExportingMessage(t('REPORT.EXPORT.DOWNLOADING'))

    // valueDf แสดงเป็น "65 %" ใน <td> — XLSX.fuzzynum() จะแปลงเป็น 0.65 (t:'n') โดย "ไม่ set format"
    // ทำให้ไฟล์ที่ export ออกมามีค่า 0.65 ดิบ Excel viewer จึงไม่ใส่ % กลับให้
    // แก้โดย mark cell ที่ขึ้นต้นด้วยตัวเลขและจบด้วย "%" / "บาท" ด้วย data-t="s" ก่อนส่งเข้า table_to_sheet
    // (XLSX จะเคารพ data-t="s" และเก็บเป็น string ตามต้นฉบับ)
    const tdNodes = componentRefExcel.current.querySelectorAll('td')
    const restoreFns: Array<() => void> = []
    tdNodes.forEach((td: HTMLTableCellElement) => {
      const text = (td.textContent || '').trim()
      if (/^[\d.,]/.test(text) && /(%|บาท)$/.test(text)) {
        const had = td.hasAttribute('data-t')
        const prev = td.getAttribute('data-t')
        td.setAttribute('data-t', 's')
        restoreFns.push(() => {
          if (had) td.setAttribute('data-t', prev || '')
          else td.removeAttribute('data-t')
        })
      }
    })

    const worksheet = XLSX.utils.table_to_sheet(componentRefExcel.current);
    restoreFns.forEach(fn => fn())

    Object.keys(worksheet).forEach((key) => {
      const cell = worksheet[key]
      if (!cell || typeof cell !== 'object') return

      if (display !== 'day') {
        if (key.startsWith("B") && typeof cell.v === 'number') {
          const formattedDate = serialNumberToThaiDate(cell.v);
          cell.v = formattedDate;
          cell.t = 's';
          cell.z = '@';
          cell.s = {
            alignment: { horizontal: "left" }
          };
        }
      }
      // กัน Excel auto-parse Thai date string เช่น '12/05/2569' เป็น MM/DD/YYYY → mark เป็น text format
      if (key.startsWith("B") && key !== 'B1' && typeof cell.v === 'string' && /^\d{1,2}\/\d{1,2}\/\d{4}/.test(cell.v.trim())) {
        cell.t = 's';
        cell.z = '@';
      }
      if (key.startsWith("H")) {
        const cellValue = cell.v;
        if (typeof cellValue === 'string' || typeof cellValue === 'number') {
          const valueStr = String(cellValue).replace(/'/g, '');
          cell.v = valueStr;
          if (/^[0-9]{2}-[0-9]{2}$/.test(valueStr)) {
            cell.z = "@";
          }
        }
      }
    });

    worksheet['!cols'] = [
      { wch: 15, },
      { wch: 15 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 }
    ];
    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "รายงาน DF หลังตัด LAB จ่ายจริง");

    // Trigger the download of the Excel file
    XLSX.writeFile(workbook, "รายงาน DF หลังตัด LAB จ่ายจริง.xlsx")
    setTimeout(() => {
      setExporting(false)
      setExportingMessage('')
    }, 1500)
  }

  // props ที่ส่งให้ <DfLabList/> (ห่อ React.memo) — ทำ reference ให้คงที่
  // เพื่อไม่ให้ตารางถูก re-render ใหม่ทุกครั้งที่ parent re-render จาก state อื่น
  const componentRefs = useMemo(() => [componentRef, componentRefCover, componentRefExcel], [])

  const selectedDoctorsList = useMemo(
    () =>
      _.chain(selectDoctors)
        .filter((v: any) => Number(v) > 0)
        .map((id: any) => doctors.find((d) => d.userId === Number(id)))
        .filter((d): d is Doctors => !!d)
        .value(),
    [selectDoctors, doctors]
  )

  const filterTable = useMemo(
    () => getAllFilter(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [branches, branchId, display, date, selectDoctors, doctors, t]
  )

  return (
    <Box sx={{ height: '100%' }}>
      <HeaderCard text={t(`REPORT.REPORT_NAME.DF_LAB`)} />
      <Box sx={{ px: 3, pt: 2 }}>
        <RadioButton
          name=""
          onChange={e => {
            setDisplay(e.target.value);
          }} options={[
            { label: t('REPORT.MONTH.DAYLY'), value: 'day' },
            { label: t('REPORT.MONTH.MONTHLY'), value: 'month' }
          ]}
          row
          defaultValue="day"
        />

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              label={t('REPORT.FILTER.BRANCH')}
              value={branchId}
              onChange={e => {
                setBranchId(Number(e.target.value));
              }}
              options={branches.map(b => ({
                value: b.branchId,
                name: b.branchName || b.branchNameEn || ''
              }))}
              width="100%"
            />
          </Grid>

          {display === 'day' && (
            <Grid item xs={12} sm={6} md={3} xl={2}>
              <InputSecondNewDatePicker
                dateFormat={'DD/MM/YYYY'}
                placeholder={t('REPORT.FILTER.DATE')}
                label={''}
                inputHeight={40}
                value={date}
                onchange={(e: any) => {
                  setDate(moment(e).format('YYYY-MM-DD'))
                }}
                views={PICKER_VIEWS.DAY || PICKER_VIEWS.MONTH || PICKER_VIEWS.YEAR}
              />
            </Grid>
          )}

          {display === 'month' && (
            <Grid item xs={12} sm={6} md={3} xl={2}>
              <InputSecondNewDatePicker
                dateFormat={`MMMM YYYY`}
                placeholder={t('REPORT.FILTER.DATE')}
                label={''}
                inputHeight={40}
                value={date}
                onchange={(e: any) => {
                  setDate(moment(e).format('YYYY-MM-DD'))
                }}
                views={PICKER_VIEWS.MONTH}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={3} xl={2}>
            {!userIdFromParam && (
              <SelectCheckBoxInput
                label={t('USER_DOCTOR')}
                options={[
                  { id: 'DOCTOR_SCHEDULE', name: t('REPORT.FILTER.DOCTOR_SCHEDULE') },
                  ...doctors.map((d: any) => ({ id: d.userId, name: d.fullname })),
                ]}
                selected={selectDoctors}
                onChange={(ids: any) => {
                  if (ids.includes('DOCTOR_SCHEDULE') && ids.length === 1) {
                    const currentSchedule = doctorSchedule.every((id) => selectDoctors.includes(id))
                    const newSelected = new Set(selectDoctors)
                    if (currentSchedule) {
                      doctorSchedule.forEach((id) => newSelected.delete(id))
                    } else {
                      doctorSchedule.forEach((id) => newSelected.add(id))
                    }
                    setSelectDoctors(['DOCTOR_SCHEDULE', ...Array.from(newSelected)])
                    return
                  }
                  setSelectDoctors(ids)
                }}
                fullWidth
                width="100%"
                searchable
                searchPlaceholder={t('REPORT.FILTER.DOCTOR_SEARCH_PLACEHOLDER')}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={6} sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
              <MainButton
                title={t('INPUT.SEARCH')}
                type="primary"
                variant="contained"
                onClick={() => {
                  setPage(1);
                  setFetch(true)
                }}
                style={{ width: '120px' }}
              />
              <DropdownButton title='พิมพ์เอกสาร' onChange={(e) => {
                if (e === 'Excel') exportTableToExcel()
                else if (e === 'PDF') {
                  setExporting(true)
                  setExportingMessage(t('REPORT.EXPORT.PREPARING_PRINT'))
                  if (isIosDevice()) {
                    printOnIos(componentRef.current, 'A4 landscape', 1122.519685, t(`REPORT.REPORT_NAME.DF_LAB`))
                  } else {
                    handlePrintPdf()
                  }
                  setTimeout(() => { setExporting(false); setExportingMessage('') }, 1500)
                }
                else if (e === 'PDFCover') {
                  setExporting(true)
                  setExportingMessage(t('REPORT.EXPORT.PREPARING_PRINT'))
                  // รอ coverData โหลดเสร็จก่อนสั่งพิมพ์ เพราะ componentRefCover ต้อง render ข้อมูลก่อนถูก clone เข้า iframe
                  fetchCover().then(() => {
                    setTimeout(() => {
                      if (isIosDevice()) {
                        printOnIos(componentRefCover.current, 'A4 portrait', 793.7007874, t(`REPORT.REPORT_NAME.DF_LAB`))
                      } else {
                        handlePrintCover()
                      }
                      setTimeout(() => { setExporting(false); setExportingMessage('') }, 1500)
                    }, 300)
                  })
                }
              }} options={[{ value: 'Excel', name: ' Excel' }, { value: 'PDF', name: ' PDF' }, { value: 'PDFCover', name: t('REPORT.EXPORT.PDF_COVER') }]} />
            </Box>

            {/* <Box >
              <UseStyled.DropdownDocument title={t('REGISTER.BUTTON.PRINT_DOCUMENT')} id="dropdown-basic" className="ml-xl-auto">
                <UseStyled.DropdownItem onClick={exportTableToExcel}>{t('Excel')}</UseStyled.DropdownItem>
                <FucntionPrint
                  content={() => componentRef.current}
                  removeIfram
                  trigger={() => <UseStyled.DropdownItem>{t('PDF')}</UseStyled.DropdownItem>}
                  style={`@page { size:  1122.519685px 793.7007874px;  margin: 0.5cm; } @media print { body { -webkit-print-color-adjust: exact; }`}
                />
                <FucntionPrint
                  content={() => componentRefCover.current}
                  removeIfram
                  trigger={() => <UseStyled.DropdownItem>{t('REPORT.EXPORT.PDF_COVER')}</UseStyled.DropdownItem>}
                  style={`@page { size:  793.7007874px 1122.519685px; margin: 0.5cm; } @media print { body { -webkit-print-color-adjust: exact; }`}
                />
              </UseStyled.DropdownDocument>
            </Box> */}
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, px: { xs: 1, xl: 3 }, pb: 4 }}>
          <DfLabList
            filterTable={filterTable}
            page={page}
            pageLimit={pageLimit}
            rowCount={rowCount}
            sortBy={sortBy}
            sortType={sortType}
            data={dfData}
            date={date}
            cover={coverData}
            display={display}
            onRequestSort={onRequestSort}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleChangePage={handleChangePage}
            componentRef={componentRefs}
            selectedDoctors={selectedDoctorsList}
          />
        </Box>
      </Box>

      <Loading show={loading} type="fullLoading" />
      {exporting && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 2500,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
          }}
        >
          <div className="loading-spinner" />
          <Typography sx={{ color: 'white', fontWeight: 500 }}>{exportingMessage}</Typography>
        </Box>
      )}
      {popFormula && <ReportFormulaDF img={imageFormula} setImg={setImageFormula} />}
    </Box>
  );
}


